export default "__VITE_ASSET__977f54f4__"